export const gameConstant = {
    SEARCH_FAIL: 'SEARCH_GAME_FAIL',
    SEARCH_SUCCESS: 'SEARCH_GAME_SUCCESS',
    SEARCH_REQUEST: 'SEARCH_GAME_REQUEST',
    GET_PLATFORMS_FAIL: 'GET_PLATFORMS_FAIL',
    GET_PLATFORMS_SUCCESS: 'GET_PLATFORMS_SUCCESS',
    GET_PLATFORMS_REQUEST: 'GET_PLATFORMS_REQUEST',
    ADD_FAIL: 'ADD_GAME_FAIL',
    ADD_SUCCESS: 'ADD_GAME_SUCCESS',
    ADD_REQUEST: 'ADD_GAME_REQUEST',
    PAGINATE_FAIL: 'PAGINATE_GAME_FAIL',
    PAGINATE_SUCCESS: 'PAGINATE_GAME_SUCCESS',
    PAGINATE_REQUEST: 'PAGINATE_GAME_REQUEST',
    GET_FAIL: 'GET_GAME_FAIL',
    GET_SUCCESS: 'GET_GAME_SUCCESS',
    GET_REQUEST: 'GET_GAME_REQUEST',
    SHOULD_FAIL: 'SHOULD_GAME_FAIL',
    SHOULD_SUCCESS: 'SHOULD_GAME_SUCCESS',
    SHOULD_REQUEST: 'SHOULD_GAME_REQUEST',
    RESET: 'RESET_GAME',
    ADD_LIST_FAIL: 'ADD_PLAY_LIST_GAME_FAIL',
    ADD_LIST_SUCCESS: 'ADD_PLAY_LIST_SUCCESS',
    ADD_LIST_REQUEST: 'ADD_PLAY_LIST_REQUEST',
};

export default gameConstant;